//homepage shopy by bestsellers
document.addEventListener('DOMContentLoaded', function() {
  // Select all the category links
  const categoryLinks = document.querySelectorAll('.shop_by_item .shop_by_title');
  
  // Loop through each link and update the href
  categoryLinks.forEach(link => {
    const currentHref = link.getAttribute('href');

    if (currentHref.indexOf('?') === -1) {
      link.setAttribute('href', currentHref + '?sort_by=best-selling');
    }

  });
});


document.addEventListener('DOMContentLoaded', function() {
  const desc = document.querySelector('.product-description');
  if (desc) desc.style.textTransform = 'none';
});



// Wrap everything in a function to avoid polluting the global scope
(function() {
  console.log("1928.com Enhancement Script Loaded!");

  // --- SMOOTH SCROLL-IN ANIMATIONS ---

  // Select all the elements we want to animate.
  // We're targeting section titles, collection lists, product grids, etc.
  const elementsToAnimate = document.querySelectorAll(
    '.section-header, .collection-list, .product-list, .image-with-text, .multicolumn, .footer__block'
  );

  // Give each of these elements our "before" state class
  elementsToAnimate.forEach(el => {
    el.classList.add('fade-in-element');
  });

  // Set up the Intersection Observer
  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      // If the element is in the viewport
      if (entry.isIntersecting) {
        // Add the 'is-visible' class to trigger the animation
        entry.target.classList.add('is-visible');
        // We only want the animation to happen once, so unobserve the element
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.1 // Trigger when 10% of the element is visible
  });

  // Start observing all the targeted elements
  elementsToAnimate.forEach(element => {
    observer.observe(element);
  });

  // --- BONUS: SLIGHT PARALLAX ON HERO BANNER ---
  // This adds a subtle depth effect to the main banner as you scroll

  const heroBanner = document.querySelector('.slideshow__media');
  if (heroBanner) {
    window.addEventListener('scroll', () => {
      const scrollPosition = window.pageYOffset;
      // Move the background image slightly slower than the scroll speed
      heroBanner.style.transform = `translateY(${scrollPosition * 0.2}px)`;
    });
  }

})();